// extracted by mini-css-extract-plugin
module.exports = {"collapse":"Collapse_collapse__3Ha_H"};